import Button from '@mui/material/Button';
import '../../styles/Ticket.css';
import '../../styles/App.css';
import EmailField from './EmailField.jsx';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Component for tickets inside of different matches

function Ticket ({
  index,
  emailCanBeEdited,
  ticketId,
  priceType,
  seatDetails,
  customerEmail,
  visitorEmail,
  setMatchData
}) 
{
  // Hook for writing email to textfield. Default value is visitor email and if null then customer email
  const [emailadd, setEmail] = useState( (visitorEmail === '' || visitorEmail) ? visitorEmail : customerEmail);
  // Hook for validating email 
  const [isEmailValid, setIsEmailValid] = useState(false);
  //Hook for disabling "save changes" -button while saving
  const [isSaving, setIsSaving] = useState(false);

  // A function for updating new data to the site after saving new changes to an email
  const updateData = () => {
      const hash = window.location.hash;

      if (!hash) {
          console.warn('No hash found in the URL');
          return;
        } else {
          fetch(`/api/tickets/hash/${hash}`)
            .then(response => {
                  if (!response.ok) {
                    throw new Error('Failed to fetch tickets data');
                  }
                  return response.json();
                })
            .then(data => setMatchData(data))
            .catch(error => console.error('Error fetching tickets:', error));
        }
  }
  // Function for handling emailfield changes
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  }
  // Function for emptying email field
  const emptyEmailField = (event) => {
    setEmail('');
  }

  // Function for saving email to the database
  const saveEmail = async (event) => {

    if (!isEmailValid) {
          alert('Sähköpostiosoite ei ole kelvollinen!');
          return;
    }

    try {
      setIsSaving(true);
      const response = await fetch(`/api/tickets/${ticketId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ visitorEmail: emailadd })
      }).finally(() => {
          setTimeout(() => {
            setIsSaving(false);
          }, 3000);
        });
      // If response is not ok, show error notification
      if (!response.ok) {
        toast.error('Tietojen tallennus epäonnistui.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
      }

      if (response.ok) {
        // On succes make a succes notification and update the site with the new ticket
        updateData()
        toast.success('Kiitos, tiedot tallennettu klo ' + new Date().getHours().toString().padStart(2, '0') + '.' + new Date().getMinutes().toString().padStart(2, '0'), {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
      }

    } catch (error) {
        toast.error('Muutosten tallennus epäonnistui!', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
    }
  };
  
  return (
    <div className="ticket-card">
      <div className="ticket-details">
        <div className="ticket-title">Lippu {index}</div>
        <div>{priceType}</div>
        { seatDetails.seatSection != null
              ? <div>Katsomon osa: {seatDetails.seatSection}</div>
              : <>
                  <div>Katsomo: {seatDetails.seatArea}</div>
                  <div>Rivi: {seatDetails.seatRow}</div>
                  <div>Paikka: {seatDetails.seatNumber}</div>
                </>
      }
      </div>
      <div className="ticket-email-area">
        <EmailField
          id={ticketId || index}
          email={emailadd}
          emailCanBeEdited={emailCanBeEdited}
          onChange={handleEmailChange}
          onValidationChange={setIsEmailValid} 
        />
      </div>
      <Button
        variant="contained"
        style={{
          display: emailCanBeEdited ? 'inline-block' : 'none',
          backgroundColor: '#8FE3B9',
          color: '#000000',
          borderRadius: '8px',
          fontWeight: 400,
          fontSize: '14px',
          fontFamily: 'Finlandica-Regular',
          marginTop: '6px',
          width: '80%',
          height: 'auto',
          alignSelf: 'center',
          marginBottom: '8px',
        }}
        onClick={saveEmail}
        disabled={isSaving}
      >
        Tallenna muutokset
      </Button>
      <Button
        variant="contained"
        style={{
          display: emailCanBeEdited ? 'inline-block' : 'none',
          backgroundColor: '#9A9995',
          color: '#FFFFFF',
          borderRadius: '8px',
          fontWeight: 400,
          fontSize: '12px',
          fontFamily: 'Finlandica-Regular',
          marginTop: '6px',
          width: '70%',
          height: 'auto',
          alignSelf: 'center',
        }}
        onClick={emptyEmailField}
      >
        Tyhjennä sähköposti
      </Button>
      <div className="cant-edit-text">
        <p
          style={{
            display: emailCanBeEdited ? 'none' : 'inline-block',
            color: '#464444',
            margin: '0',
            fontSize: '14px',
            fontFamily: 'Finlandica-Regular',
            textAlign: 'center',
            lineHeight: '18px'
          }}
        >
          Et pysty enää tekemään muutoksia sähköpostiosoitteeseen.
        </p>
      </div>
    </div>
  )
};

export default Ticket;